//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        pageConfig:Object,
        list:Array,
        total:Number
    },
    data(){
        return{
            layout:['total','prev','body','next','limit','page'],
        }
    },
    methods:{
        formatType(value){
            switch (value) {
                case 1:
                    return '现金券'
                case 2:
                    return '小时券'
            }
        },
        formatPlatform(state){
            let str='';
            switch (state){
                case 1:
                    str='道闸后台';
                    break;
                case 2:
                    str='商户平台';
                    break;
            }
            return str
        },
        formatPayType(state){
            let str='';
            switch (state){
                case 1:
                    str='微信';
                    break;
                case 2:
                    str='支付宝';
                    break;
                case 3:
                    str='现金';
                    break;
                case 4:
                    str='其他支付';
                    break;
            }
            return str
        },
        pageChange(value) {
            this.$parent.pageConfig.current = value
            this.$emit('pageChange')
        },
        sizeChange(value) {
            this.$parent.pageConfig.pageSize = value
            this.$emit('pageChange')
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/Table.vue